export const displayValues = {
	'model': 'Model',
	'price': 'Price',
	'excavatorOperatingWeightMax(t)': 'Excavator operating weight max (t)',
	'annualOperatingHours(h)': 'Annual operating hours (h)',
	'estimatedMachineLifetime': 'Estimated Machine Lifetime (h)',
	'production,(Tonnes/hour)': 'Production, (Tonnes/hour)',
	'tramming(%)': 'Tramming (%)',
	'undercarriageLifetime(h)': 'Undercarriage lifetime (h)',
	'revenuePerTonne($)': 'Revenue per Tonne ($)',
	'labourHoursForUndercarriageMaintenanceDuringLifetime':
		'Labour hours for undercarriage maintenance during lifetime',
	'labourCostPerHourForMaintenance': 'Labour cost per hour for maintenance',
	'maintenanceCostPerHour($)(Parts+Fluids,ExcludingUndercarriageRelatedParts':
		'Maintenance cost per hour ($) (parts + fluids, Excluding undercarriage related parts)',
	'undercarriageCostPerHour($)(OnlyUndercarriageRelatedParts)':
		'Undercarriage cost per hour ($) (Only undercarriage related parts)',
	'averageTravellingSpeedOnTracks(km/h)': 'Average travelling speed on tracks (km/h)',
	'averageTravellingSpeedOnSleipners(km/h)':
		'Average travelling speed on Sleipners (km/h)',
	'averageFuelPrice($/l)': 'Average fuel price ($/l)',
	'fuelConsumptionW/OSleipner(liters/hour)':
		'Fuel Consumption W/O Sleipner (liters/hour)',
	'fuelConsumptionWSleipner(liters/hour)': 'Fuel Consumption W Sleipner (liters/hour)',
};

export const displayValuesWithUnits = {
	'Undercarriage yearly savings': {
		displayText: 'Undercarriage yearly savings',
		unit: '$',
	},
	'Increased tonnes per year': {
		displayText: 'Increased tonnes per year',
		unit: 'tonnes',
	},
	'Investment payback time (month)': {
		displayText: 'Investment payback time',
		unit: 'months',
	},
	'Annual saved travelling time (h)': {
		displayText: 'Annual saved travelling time',
		unit: 'h',
	},
	'Annual time spent travelling without Sleipner (h)': {
		displayText: 'Annual time spent travelling without Sleipner',
		unit: 'h',
	},
	'Annual time spent travelling with Sleipner (h)': {
		displayText: 'Annual time spent travelling with Sleipner',
		unit: 'h',
	},
	'Annual time spent travelling with Sleipner (%)': {
		displayText: 'Annual time spent travelling with Sleipner',
		unit: '%',
	},
	'Utilization without Sleipner (%)': {
		displayText: 'Utilization without Sleipner',
		unit: '%',
	},
	'Utilization with Sleipner (%)': {
		displayText: 'Utilization with Sleipner',
		unit: '%',
	},

	'Annual increase in production (tonnes)': {
		displayText: 'Annual increase in production',
		unit: 'tonnes',
	},
	'Production increase ($)': {
		displayText: 'Annual production increase',
		unit: '$',
	},
	'Fuel saved with Sleipner in year (litres)': {
		displayText: 'Fuel saved with Sleipner in year',
		unit: 'litres',
	},
	'Fuel saved with Sleipner during lifetime (litres)': {
		displayText: 'Fuel saved with Sleipner during lifetime',
		unit: 'litres',
	},
	'Yearly fuel savings ($)': {
		displayText: 'Yearly fuel savings',
		unit: '$',
	},
	'Lifetime fuel savings ($)': {
		displayText: 'Lifetime fuel savings',
		unit: '$',
	},
	'CO2 reduction with Sleipner in year (tonnes)': {
		displayText: 'CO2 reduction with Sleipner in year',
		unit: 'tonnes',
	},
	'CO2 reduction with Sleipner in lifetime (tonnes)': {
		displayText: 'CO2 reduction with Sleipner in lifetime',
		unit: 'tonnes',
	},
	'Lifetime CO2 kilometers compared to low emission hybrid cars': {
		displayText:
			'Amount of saved CO2 kilometers from using Sleipner, but driven with low emission hybrid cars',
		unit: 'km',
		icon: 'hybrid',
	},
	'The amount of times you can drive around the world': {
		displayText: 'Number of times you could drive around the world with the CO2 savings',
		unit: 'times',
		icon: 'globe',
	},
	'The amount of times to drive to moon and back': {
		displayText:
			'Number of times you could drive to the moon and back with the CO2 savings',
		unit: 'times',
		icon: 'rocket',
	},
	'LCC cost reduction during lifetime ($)': {
		displayText: 'LCC cost reduction during lifetime',
		unit: '$',
	},
	'LCC cost reduction ($/h)': {
		displayText: 'LCC cost reduction ($/h)',
		unit: '$/h',
	},
	'LCC cost reduction (%)': {
		displayText: 'LCC cost reduction',
		unit: '%',
	},
	'Annual undercarriage rebuild part savings ($)': {
		displayText: 'Annual undercarriage rebuild part savings',
		unit: '$',
	},
	'Lifetime undercarriage rebuild savings': {
		displayText: 'Lifetime undercarriage rebuild savings',
		unit: '$',
	},
	'Undercarriage related labour hours saving during lifetime ($)': {
		displayText: 'Undercarriage related labour hour cost savings during lifetime',
		unit: '$',
	},
	'Undercarriage related labour hours saving during lifetime (h)': {
		displayText: 'Undercarriage related labour hours saving during lifetime',
		unit: 'h',
	},
};

export function getDisplayValues(key, displayTextOverWrite = null) {
	if (displayTextOverWrite) {
		return {...displayValuesWithUnits[key], key: key, displayText: displayTextOverWrite};
	}

	return {...displayValuesWithUnits[key], key: key};
}
